// PDF
const ABOUT_ESHINSEI_PDF_NAME = "MDB利用許諾申請のお願い Ver2.5.pdf";
const ESHINSEI_MANUAL_PDF_NAME = "MDB-e申請 ユーザマニュアル Ver2.5.pdf";
const PRIVACY_LAW_PDF_NAME = "MDB利用許諾申請と個人情報保護法.pdf";
const ESHINSEI_FAQ_PDF_NAME = "MDB-e申請 FAQ Ver2.5.pdf";

const ABOUT_ESHINSEI_PDF_LINK = "MDB利用許諾申請のお願いVer2.5.pdf";
const ESHINSEI_MANUAL_PDF_LINK = "MDB-e申請_ユーザマニュアル_Ver2.5.pdf";
const PRIVACY_LAW_PDF_LINK = "MDB利用許諾申請と個人情報保護法.pdf";
const ESHINSEI_FAQ_PDF_LINK = "MDB-e申請_FAQ_Ver2.5.pdf";

// Google Form
const REGIST_ACCOUNT_GOOGLE_FORM_NAME = "MDB-e申請 新規登録フォーム";
const UPDATE_ACCOUNT_GOOGLE_FORM_NAME = "MDB-e申請 登録内容変更フォーム";
const REGIST_ACCOUNT_GOOGLE_FORM_LINK = "https://forms.gle/xLgYU4FgVBcBCywd8";
const UPDATE_ACCOUNT_GOOGLE_FORM_LINK = "https://forms.gle/6Eu8nxicVbuZ4De28";

// Excel
const REGIST_ACCOUNT_EXCEL_NAME = "「MDB-e申請」新規登録票.xlsx";
const UPDATE_ACCOUNT_EXCEL_NAME = "「MDB-e申請」登録内容変更票.xlsx";
const REGIST_ACCOUNT_EXCEL_LINK = "「MDB-e申請」新規登録票.xlsx";
const UPDATE_ACCOUNT_EXCEL_LINK = "「MDB-e申請」登録内容変更票.xlsx";

export const docs = [
  ABOUT_ESHINSEI_PDF_NAME,
  ESHINSEI_MANUAL_PDF_NAME,
  PRIVACY_LAW_PDF_NAME,
  ESHINSEI_FAQ_PDF_NAME,
  REGIST_ACCOUNT_GOOGLE_FORM_NAME,
  UPDATE_ACCOUNT_GOOGLE_FORM_NAME,
];

export const excels = [
  REGIST_ACCOUNT_EXCEL_NAME,
  UPDATE_ACCOUNT_EXCEL_NAME,
];

export const DOCS_MAP = new Map([
  // pdf
  [ABOUT_ESHINSEI_PDF_NAME, ABOUT_ESHINSEI_PDF_LINK],
  [ESHINSEI_MANUAL_PDF_NAME, ESHINSEI_MANUAL_PDF_LINK],
  [PRIVACY_LAW_PDF_NAME, PRIVACY_LAW_PDF_LINK],
  [ESHINSEI_FAQ_PDF_NAME, ESHINSEI_FAQ_PDF_LINK],

  // google form
  [REGIST_ACCOUNT_GOOGLE_FORM_NAME, REGIST_ACCOUNT_GOOGLE_FORM_LINK],
  [UPDATE_ACCOUNT_GOOGLE_FORM_NAME, UPDATE_ACCOUNT_GOOGLE_FORM_LINK],

  // excel
  [REGIST_ACCOUNT_EXCEL_NAME, REGIST_ACCOUNT_EXCEL_LINK],
  [UPDATE_ACCOUNT_EXCEL_NAME, UPDATE_ACCOUNT_EXCEL_LINK],
]);